"use strict";
/**
 * @packageDocumentation
 * @module Logger.Builders
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerTypeBuilder = void 0;
/**
 * start by run LoggerTypeBuilder.initial()
 * and chain with many option
 */
var LoggerTypeBuilder = /** @class */ (function () {
    function LoggerTypeBuilder() {
        this.badgeFn = function () { return ""; };
        this.colorFn = function (c) { return c.reset; };
        this.label = "";
        this.level = "info";
    }
    LoggerTypeBuilder.initial = function () {
        return new LoggerTypeBuilder();
    };
    LoggerTypeBuilder.prototype.withNewBadge = function (fn) {
        this.badgeFn = fn;
        return this;
    };
    LoggerTypeBuilder.prototype.withNewColor = function (fn) {
        this.colorFn = fn;
        return this;
    };
    LoggerTypeBuilder.prototype.withLabel = function (label) {
        this.label = label;
        return this;
    };
    LoggerTypeBuilder.prototype.withLevel = function (lv) {
        this.level = lv;
        return this;
    };
    LoggerTypeBuilder.prototype.get = function () {
        return {
            badge: this.badgeFn,
            color: this.colorFn,
            label: this.label,
            level: this.level,
        };
    };
    LoggerTypeBuilder.prototype.getType = function (name) {
        var _a;
        return _a = {},
            _a[name] = this.get(),
            _a;
    };
    return LoggerTypeBuilder;
}());
exports.LoggerTypeBuilder = LoggerTypeBuilder;
//# sourceMappingURL=LoggerTypeBuilder.js.map